<template lang="html">
    <div class="container" id="text-page" style="text-align: center;">
        <loading-component-s1 v-if="loading"></loading-component-s1>

        <div v-if="!loading">
            <div v-if="row.status == 'success'">
                <img src="/public/images/circle-check.png" alt="success" width="30%">
                <br>
                <h3>We have received your payment correctly</h3>

            </div>
            <div v-else>
                <img src="/public/images/circle_croos.png" alt="success" width="30%">
                <br>
                <h3>Payment not received</h3>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
	export default {
		data(){
			return {
                loading:false,
				row:{},
			}
		},
		methods:{
			checkStatus(){
				this.$root.isLoading = true;
                var data = {
                    id:null,
                    session_id:null,
                    orders_transfers_id:null,
                };
                if(this.$route.query.orders_transfers_id){
                    data.id = this.$route.query.id;
                    data.session_id = this.$route.query.session_id;
                    data.orders_transfers_id = this.$route.query.orders_transfers_id;
                }
                else{
                    data.id = this.$route.query.id;
                    data.session_id = this.$route.query.session_id;
                }
                
				axios.post(tools.url('/api/statuspaymentstripe'),data).then((response)=>{
					this.row = response.data;
			
					this.loading = false;
			    }).catch((error)=>{
			        this.$parent.handleErrors(error);
					this.loading = false;
			    });
			},
	
		},
        mounted() {
            this.loading = true;
            this.checkStatus();
        }
    }
</script>